import React, { useEffect, useState } from 'react';
import { Document, Hotels } from '../../api/services/next';
import { useTextResources } from '../../language';
import moment from 'moment'
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { onError, onSuccess } from '../../components/shared/messages';
import HotelsDropDown from '../../components/shared/HotelsDropDown';
import {  Form } from 'semantic-ui-react';
import DocumentTypeDropDown from '../../components/shared/DocumentTypeDropDownList'
import DocumentSubTypeDropDown from '../../components/shared/DocumentSubTypeDropDowmList'
import NumericInput from '../../components/shared/NumericInput';
import CheckBoxToggle from '../../components/shared/CheckBoxToggle'
import { useLoader } from '../../hooks/useLoader';
import { dateFormat, MenuActions } from '../../components/shared/constants';
import { DatePicker } from '../../components/shared/DatePicker';
import GridSearchTemplate from '../GridSearchTemplate';
import CheckboxWrapper from '../../components/shared/Checkbox';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { onUpdateGridHandler } from '../../components/GridPanel/utility';

export const DocumentSeriesPage = () => {

    const hotelChainId = window.optima?.user?.HotelChainId || window.user?.HotelChainId
    const text = useTextResources()
    const [data, setData] = useState([])
    const [hotels, setHotels] = useState([])
    const [docTypes, setDocTypes] = useState([])
    const [docSubTypes, setDocSubTypes] = useState([])
    const loader = useLoader()
    const [spec, setSpec] = useState({
        HotelChainId: hotelChainId
    })

    useEffect(() => {
        (async () => {
            try {
                const [hotelsData, documentType, documentSubType] = await Promise.all([
                    Hotels.GetHotels(),
                    Document.GetDocumentType(),
                    Document.GetDocumentSubType()
                ]);
                setHotels(hotelsData);
                setDocTypes(documentType);
                setDocSubTypes(documentSubType);
            } catch (error) {
                onError(error);
            }
        })();
    }, []);

    const save = () => {
        (async () => {
            try {
                loader(true)
                data.forEach(d => d.HotelChainId = hotelChainId)
                await Document.PostDocumentSeries({
                    ...spec,
                    DocumentSeries: data,
                });
                await Document.GetDocumentSeries(spec).then(
                    setData
                ) ;
                onSuccess()
            } catch (error) {
                onError(error)
            } finally {
                loader(false)
            }
        })()
    }
    useEffect(() => {
        if (window.optima?.commands) {
            window.optima.commands.unsubscribe(MenuActions.save)
            window.optima.commands.subscribe(MenuActions.save, save);
        }
    }, [data])

    const onUpdate = (added, changed, deleted) => {
        const updated = onUpdateGridHandler(data, added, changed, deleted);
        setData(updated);
    }

    const dateFormatter = ({ value }) => {
        return value && moment(value).format(dateFormat)
    }

    const docSubTypeFormatter = ({ value }) => {
        const docSubType = docSubTypes.find(x => x.Id == value)
        return docSubType?.Name || ''
    }
    const docTypeFormatter = ({ value }) => {
        const docType = docTypes.find(x => x.Id == value)
        return docType?.Name || ''
    }
    const hotelFormatter = ({ value }) => {
        const hotel = hotels.find(x => x.Id == value)
        return hotel?.Name || ''
    }
    const checkBoxFormatter = ({ value }) => {
        return <CheckBoxToggle readOnly checked={value} />
    }
    const lastSeriesFormatter = ({value}) =>{
        const lastSeries = value?.split('-') || ''
        switch(lastSeries.length) {
            case 4:
              return lastSeries[2];
            case 2:
                return lastSeries[0];
            default:
              return '';
        }
    }

    const gridOptions = {
        search: {
            title: text("DocumentSeries"),
            fields: [
                <Form.Field control={HotelsDropDown} clearable label={text("Hotel")} key="HotelId" />,
                <Form.Field control={DocumentTypeDropDown} clearable label={text("DocumentType")} key="DocumentTypeId" />,
                <Form.Field control={DocumentSubTypeDropDown} clearable label={text("DocumentSubType")} key="DocumentSubTypeId" />,
                <DatePicker
                    type="basic"
                    label= {`${text("FromDate")} ` }
                    name="FromDate"
                    key="FromDate"
                />,
                <DatePicker
                    type="basic"
                    label= {`${text("ToDate")}` }
                    name="ToDate"
                    key="ToDate"
                />,
                <CheckboxWrapper
                    label={text("Active")}
                    key="IsActive"
                />
            ],
            initial: { HotelChainId: hotelChainId},
            api: Document.GetDocumentSeries,
            searchOnLoad: true
        },
        grid: {
            columns: [
                { name: 'HotelId', title: text("Hotel"), formatter: hotelFormatter, editor: <HotelsDropDown fluid data={hotels} spec={{ HotelsForAllChains: true }} /> },
                { name: 'DocumentTypeId', title: text("DocumentType"), formatter: docTypeFormatter, editor: <DocumentTypeDropDown fluid data={docTypes} /> },
                { name: 'DocumentSubTypeId', title: text("DocumentSubType"), formatter: docSubTypeFormatter, editor: <DocumentSubTypeDropDown fluid data={docSubTypes} /> },
                { name: 'StartDate', title: text("StartDate"), formatter: dateFormatter, editor: <SemanticDatepicker format={dateFormat} />, valueField: value => moment(value).toDate() },
                { name: 'InitialSeriesNumber', title: text("StartValueForInvoiceNum"), editor: <NumericInput digits={0} min={0} /> },
                { name: 'LastDocumentNumber', title: text("LastCurrentValueForSeries"),formatter:lastSeriesFormatter,},
                { name: 'IsActive', title: text("Active"), formatter: checkBoxFormatter, editor: <CheckBoxToggle style={{ marginTop: 8, marginBottom: 8 }} />, customProps: ({ value }) => { return { checked: value } } }
            ],
            columnExtensions: [
                { columnName: 'LastDocumentNumber', editingEnabled: false }
            ],
            editable: {
                allowAdd: true,
                allowEdit: true
            }
        }
    }


return (<GridSearchTemplate options={gridOptions} onGridUpdate={onUpdate} onSearchChange={setSpec} onSearchComplete={data => { setData(data); }} data={data}/>)

}
